import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: 'https://nfplie4d55g5xmthzwsop6m3c4.appsync-api.us-east-2.amazonaws.com/graphql',
      region: 'us-east-2',
      defaultAuthMode: 'apiKey',
      apiKey: 'da2-xwo5zz2jvjhkjda3x3xpcjk5eq'
    }
  }
});

export const client = generateClient();
